'use client';

import fork from '@haaretz/l-fork.macro';
import nameValidator from '@haaretz/s-validators/nameValidator';
import React from 'react';

import RequiredField from '../RequiredField';
import { namePattern, onInputNameHandler } from '../utils/nameFields';

import type { State } from '../types';
import type { TextFieldProps } from '@haaretz/s-text-field';

export default function LastNameField(props: TextFieldProps) {
  const [state, setState] = React.useState<State>('default');

  const textFieldRef = React.useRef<HTMLInputElement | null>(null);

  const getDescription = (value: string) => nameValidator(value, 'lastName');

  return (
    <RequiredField
      inputState={state}
      setInputState={setState}
      label={fork({ default: 'שם משפחה', hdc: 'Last Name' })}
      name={props.name || 'lastName'}
      data-testid="last-name-field"
      minLength={2}
      maxLength={40}
      pattern={namePattern}
      ref={textFieldRef}
      onInput={onInputNameHandler}
      description={getDescription}
      {...props}
    />
  );
}
